import * as React from "react";
import { ErrataView } from "../service/index.js";
import { WidgetFrame } from "./WidgetFrame.jsx";
export { ErrataWidget, ErrataView };
/**
 * Вывод отчёта об ошибках как секции учебного продукта.
 * @param {Object} props - Атрибуты элемента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {ErrataWidget} from "../personal-studio-components/studio/index.js";
 * if(request.hasError()) return <ErrataWidget errata={request.getErrata()}/>;
 * @see {@link ../service/ErrataView.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ErrataWidget(
  {
    errata = {}
  }) {
  return (
    <WidgetFrame
      type="danger"
      icon="warn"
      title="Произошла ошибка">
      <ErrataView errata={errata} />
    </WidgetFrame>
  );
}
